export default __webpack_public_path__ + "static/media/Path 22.13886ac7.svg";